import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';

import { Grid, Paper, makeStyles } from '@material-ui/core';

import useAccounts from 'src/hooks/useAccounts';
import apiService from 'src/services/api.service';

import EDIChart from './EDIChart';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    '& h6': {
      fontWeight: 600,
    },
    padding: theme.spacing(2),
    borderRadius: 8,
  },
}));

export default function SentReceivedChart(props) {
  const classes = useStyles();
  const history = useHistory();
  const [isFilesReceivedLoading, setIsFilesReceivedLoading] = useState(false);
  const [isFilesSentLoading, setIsFilesSentLoading] = useState(false);
  const [filesReceivedChartData, setFilesReceivedChartData] = useState([]);
  const [filesSentChartData, setFilesSentChartData] = useState([]);
  const [filesSentChartTitle, setFilesSentChartTitle] = useState('Number of Files Sent');
  const { accountId, accountName } = useAccounts();

  useEffect(() => {
    let isCancelled = false;

    const reloadFilesReceivedChartData = (companyAccountId) => {
      if (companyAccountId) {
        setIsFilesReceivedLoading(true);
        apiService
          .getEDIFilesReceivedChart(companyAccountId)
          .then((result) => {
            if (!isCancelled) {
              setFilesReceivedChartData(result.data);
            }
            setIsFilesReceivedLoading(false);
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) history.push('/login');
          });
      }
    };

    const reloadFilesSentChartData = (companyAccountId) => {
      if (companyAccountId) {
        setIsFilesSentLoading(true);
        apiService
          .getEDIFilesSentChart(companyAccountId)
          .then((result) => {
            if (!isCancelled) {
              setFilesSentChartData(result.data);
            }
            setIsFilesSentLoading(false);
          })
          .catch((err) => {
            if (err.response && err.response.status === 401) history.push('/login');
          });
      }
    };

    if (accountId && accountName) {
      setFilesSentChartTitle(`Number of Files Sent to ${accountName}`);
      reloadFilesReceivedChartData(accountId);
      reloadFilesSentChartData(accountId);
    }

    return () => {
      isCancelled = true;
      setIsFilesReceivedLoading(false);
    };
  }, [accountId, accountName]);

  return (
    <Paper className={classes.root}>
      <Grid container spacing={3} direction="row" justify="flex-start" alignItems="flex-start">
        <Grid item xs={12}>
          <EDIChart
            ChartId="FileReceivedChart"
            Title="Number of Files Received by Verus Global"
            IsLoading={isFilesReceivedLoading}
            ChartData={filesReceivedChartData}
          />
        </Grid>
        <Grid item xs={12}>
          <EDIChart ChartId="FileSentChart" Title={filesSentChartTitle} IsLoading={isFilesSentLoading} ChartData={filesSentChartData} />
        </Grid>
      </Grid>
    </Paper>
  );
}
